import { useApolloClient } from '@apollo/client/react';
import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { useRecordContext } from 'react-admin';

import {
  AdminGetUserFeaturesDocument,
  AdminUserDetailsFragment,
} from '../../../../graphql/types';
import { ScopedFeatureGrants } from '../../FeatureGrant';
import { MemberEffectiveFeatures } from './MemberEffectiveFeatures';

export const MemberFeatureGrantsTab: React.FC = () => {
  const record = useRecordContext<AdminUserDetailsFragment>();
  const client = useApolloClient();

  if (!record) {
    return null;
  }

  const reresolveFeatures = () => {
    // Failures surface through the section's own error state, so there is
    // nothing to handle here beyond not floating the rejection.
    client
      .refetchQueries({ include: [AdminGetUserFeaturesDocument] })
      .catch(() => {});
  };

  return (
    <>
      <MemberEffectiveFeatures />

      <Box mt={4}>
        <Typography variant="h6" fontSize={16}>
          Grants on this member
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Grants targeting this member directly (scope = user). Grants from
          parent scopes are managed on the client, studio, or location record.
        </Typography>
      </Box>
      <ScopedFeatureGrants
        scopeType="user"
        scopeId={record.id}
        clientId={record.fitClient?.id}
        storeKey={`user-${record.id}-feature-grants`}
        onGrantChange={reresolveFeatures}
      />
    </>
  );
};
